import Flash from '@/ui/Flash';
import { IEvaluation } from '@/lib/evaluationsApi';

type TTargetCommitFlashProps = {
  evaluation: IEvaluation;
  targetPath: string;
  targetBranch: string;
};

const TargetCommitFlash: React.FC<TTargetCommitFlashProps> = ({ evaluation, targetPath, targetBranch }) => {
  return (
    <Flash.Info>
      {targetPath !== evaluation.resource.path ? (
        <div>
          Results will be commited to <b>{targetPath}</b> on the{' '}
          {targetBranch === evaluation.resource.version ? (
            <span>
              original branch (<b>{evaluation.resource.version}</b>)
            </span>
          ) : (
            <span>
              <b>{targetBranch}</b> branch
            </span>
          )}
          .
        </div>
      ) : (
        <div>
          Results will overwrite the existing file on the{' '}
          {targetBranch === evaluation.resource.version ? (
            <span>
              original branch (<b>{evaluation.resource.version}</b>)
            </span>
          ) : (
            <span>
              <b>{targetBranch}</b> branch
            </span>
          )}
          .
        </div>
      )}
    </Flash.Info>
  );
};

type TTargetWorkspaceFlashProps = {
  evaluation: IEvaluation;
};

const TargetWorkspaceFlash: React.FC<TTargetWorkspaceFlashProps> = ({ evaluation }) => {
  return (
    <Flash.Info>
      <div>
        Results will be saved to <b>{evaluation.resource.path}</b> in the current workspace. You will be able commit the
        changes later.
      </div>
    </Flash.Info>
  );
};

type TTargetStatusFlashProps = {
  evaluation: IEvaluation;
  targetPath: string;
  targetType: 'commit' | 'file';
  targetBranch: string;
};

const TargetStatusFlash: React.FC<TTargetStatusFlashProps> = ({ evaluation, targetType, targetPath, targetBranch }) => {
  return targetType === 'commit' ? (
    <TargetCommitFlash evaluation={evaluation} targetPath={targetPath} targetBranch={targetBranch} />
  ) : (
    <TargetWorkspaceFlash evaluation={evaluation} />
  );
};

export default TargetStatusFlash;
